import { GTMGuideEN } from '@/core/components/help-and-support/quick-answers/gtm-guide/en'
import { GTMGuideES } from '@/core/components/help-and-support/quick-answers/gtm-guide/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/gtm-guide/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <GTMGuideEN />
    case 'es':
      return <GTMGuideES />
  }
}
